import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.daily.facebook_story,
    (task) => {
        return {
            task
        }
    }
)